<script setup>
import CreateTicketStep from '#modules/support/components/Ticket/Steps/CreateTicketStep.vue';
import CFButton from '@/ui/Button/CFButton.vue';
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import CFIcon from '@/ui/Icon/CFIcon.vue';

const { open } = useTicketStore();
</script>

<template>
    <div class="flex h-full grow flex-col items-center justify-center gap-6 text-center">
        <CFIcon
            name="alert-triangle"
            class="text-primary h-10 w-auto"
        />

        <h1 class="max-w-sm text-lg font-bold">{{ $t('invoices.error_retrieving_invoices') }}</h1>

        <CFButton
            variant="outline"
            @click="open(CreateTicketStep)"
        >
            {{ $t('invoices.ask_question') }}
        </CFButton>
    </div>
</template>
